module.exports = __webpack_public_path__ + "img/signable_full_cropped.7fe0eb7a.svg";